import { FC } from "react";
import cx from "classnames";

import LogicSelect, { ILogicOptions } from "./../../../../../../libs/logicSelect";
import { ICondition, IRule } from "./../../../../../../store/logic/types";
import Icon, { IconTypes } from "./../../../../../../libs/Icon";
import { IField } from "./../../../../../../store/fields/types";
import Button from "./../../../../../../libs/Button";
import ConditionSelect from "./ConditionSelect";
import StateSelect from "./StateSelect";

import styles from "./styles.module.scss";

interface IProps {
    index: number;
    currentRuleIndex: number;
    condition: ICondition;
    sortedConditionFields: ILogicOptions;
    fieldIds: IField[];
    currentRule: IRule;
    setCurrentRule: (newRule: IRule) => void;
}

const Condition: FC<IProps> = ({ index, condition, sortedConditionFields, fieldIds, currentRule, setCurrentRule }) => {
    const handleAddCondition = () => {
        currentRule.conditions.push({ _id: "", condition: "", target_id: "", value: "", isValue: true });
        setCurrentRule({ ...currentRule });
    };

    return (
        <div key={index} className={styles.condition}>
            <LogicSelect
                placeholder="Select a condition field "
                handleChange={newKey => {
                    currentRule.conditions[index]._id = newKey;
                    currentRule.conditions[index].condition = "";
                    setCurrentRule({ ...currentRule, conditions: currentRule.conditions });
                }}
                options={sortedConditionFields}
                valueKey={condition._id}
            />

            <StateSelect
                rule={currentRule}
                condition={condition}
                fieldIds={fieldIds}
                index={index}
                setCurrentRule={setCurrentRule}
            />

            <ConditionSelect
                rule={currentRule}
                condition={condition}
                sortedConditionFields={sortedConditionFields}
                index={index}
                setCurrentRule={setCurrentRule}
            />

            {currentRule.conditions.length !== 1 && currentRule.conditions.length - 1 !== index ? (
                <div className={styles.deleteBtn}>
                    <span className={styles.trashDecoration}></span>
                    <Icon
                        className={styles.trash}
                        type={IconTypes.TRASH}
                        size={20}
                        onClick={() => {
                            currentRule.conditions.splice(index, 1);
                            setCurrentRule({ ...currentRule });
                        }}
                    />
                    <span className={styles.trashDecoration}></span>
                </div>
            ) : null}
            {index === currentRule.conditions.length - 1 ? (
                <div className={styles.conditionBtns}>
                    <Button
                        className={cx(styles.addConditionBtn, {
                            [styles.shortConditionBtn]: index > 0,
                        })}
                        text="Add Condition"
                        leftIcon={IconTypes.ADD}
                        onClick={handleAddCondition}
                    />
                    {index > 0 ? (
                        <Icon
                            type={IconTypes.TRASH}
                            className={styles.lastTrash}
                            size={20}
                            onClick={() => {
                                currentRule.conditions.splice(index, 1);
                                setCurrentRule({ ...currentRule });
                            }}
                        />
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default Condition;
